import React, { useEffect, useState, useRef } from "react";
import DynamicTable from "../DynamicTable";

const SectionThree = (props) => {
    const { handleButtonClick, setSelectedOptions, selectedOptions, toggleOption ,data ,showMaximumChat } = props

    const [onClickYes, setOnClickYes] = useState(false);
    const [onClickNo, setOnClickNo] = useState(false);


    const isYesStepValid = (data?.step_3_yes_next_steps || '' ).toLowerCase() !== 'no';
    const isNoStepValid = (data?.step_3_no_next_steps || '').toLowerCase() !== 'no';

    // useEffect(()=>{
    //     if (onClickNo && data?.step_3_no_text?.toLowerCase() === "nan") {
    //         props?.addMessages("Work Order", 10);
    //     }
    // }, [onClickNo, onClickYes])


    // useEffect(()=>{

    //     if(onClickYes && data?.step_3_yes_call_logs){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_3_yes_call_logs })
    //           );
    //     }
    //     if(isNoStepValid && data?.step_3_no_call_logs ){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_3_no_call_logs })
    //           );
    //     }
    // })


    return (
        <>
            <div className="error-message-head1" style={{fontSize : showMaximumChat && '16px'}} >{data?.step_3_title}</div>
            <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_3_desc}}></div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        localStorage.setItem(
                            "troubleShooting",
                            JSON.stringify({ key1: data?.step_3_yes_call_logs })
                          );
                        handleButtonClick(3, "yes",{section : 'three',value:isYesStepValid});
                        
                        setOnClickYes(true);
                        setOnClickNo(false);

                        if (isYesStepValid) {
                            setSelectedOptions([true, true, true, true, false, false, false]);
                        } else{
                            setSelectedOptions([true, true, true, false, false, false, false]);
                        }
                    }}
                    className={`option-button ${toggleOption[3] === "yes" ? "clicked" : ""
                        }`}
                    
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        localStorage.setItem(
                            "troubleShooting",
                            JSON.stringify({ key1: data?.step_3_no_call_logs })
                          );
                        handleButtonClick(3, "no",{section : 'three',value:isNoStepValid});
                        
                        setOnClickYes(false);
                        setOnClickNo(true);
                        if (isNoStepValid) {
                            setSelectedOptions([true, true, true, true, false, false, false]);
                        }else{
                            setSelectedOptions([true, true, true, false, false, false, false]);
                        }
                    }}
                    className={`option-button ${toggleOption[3] === "no" ? "clicked" : ""
                        }`}
                    
                >
                    No
                </button>
            </div>
            {onClickYes && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_3_yes_text}}></div>}
            {onClickNo && data?.step_3_no_text?.toLowerCase() !== "nan" && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_3_no_text}}></div>}
            {onClickYes && data?.step_3_yes_call_logs && <DynamicTable data={data?.step_3_yes_call_logs} /> }
            {onClickNo && data?.step_3_no_call_logs && <DynamicTable data={data?.step_3_no_call_logs} /> }
        </>
    )
}

export default SectionThree
